import Vue from 'vue'
import { isObject as _isObject } from 'vuetify/es5/util/helpers'
import get from 'lodash/get'
import axios from 'axios'

export const sleep = (delay) => {
  return new Promise((resolve) => setTimeout(resolve, delay))
}

export const alert = (options) => {
  const alert = Vue.prototype.$alert
  alert.show(options)
  return alert
}

export const isObject = _isObject

export const error = (err, defaultMsg) => {
  if (!axios.isCancel(err)) {
    return new Promise((resolve) => {
      alert({ text: get(err, 'response.data.Msg_Erro', defaultMsg), buttons: { 'OK': resolve } })
    })
  }

  return new Promise(() => false)
}
